import { default as ApiConstants } from 'shared/constants/ApiConstants.json';
import ApiUtils from 'shared/modules/ApiUtils';

const getMaterialsAPI = () => ApiUtils.getRequest(ApiConstants.MATERIALS_ENDPOINT);

export { getMaterialsAPI };
